import PersonIcon from '@mui/icons-material/Person'
import { Box, Typography, useTheme } from '@mui/material'
import HeaderLoading from 'components/Loading/HeaderLoading'
import { useMemo } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { PageContainer, PageHeader, TabConfig, TabNavigation } from 'theme/components'
import { useContact } from '../../api/aws/useContact'
import Loading from '../Loading/Loading'

const ContactPage = () => {
  const { contactId } = useParams()
  const { data: contact, isLoading: contactLoading, isError: contactError } = useContact(contactId)
  const theme = useTheme()

  // Define tabs configuration
  const tabs: TabConfig[] = useMemo(
    () => [
      { label: 'Details', path: 'details' },
      { label: 'Additional Info', path: 'additionalinfo', disabled: true },
    ],
    []
  )

  if (contactLoading) {
    return <Loading />
  }

  if (contactError) {
    return <Typography>Error loading contact details</Typography>
  }

  return (
    <>
      <Box>
        <PageHeader
          name={contact?.name || ''}
          photoUrl={contact?.photoUrl}
          avatarColor={theme.palette.icon.contacts}
          icon={<PersonIcon sx={{ color: theme.palette.icon.contacts }} />}
          iconColor={theme.palette.icon.contacts}
          title="Contact Details"
          isLoading={contactLoading}
          loadingComponent={<HeaderLoading chipCount={0} showVerticals={false} />}
        />
      </Box>

      <TabNavigation tabs={tabs} basePath={`/contacts/${contactId}`} />

      <PageContainer height="calc(100vh - 110px)">
        <Outlet />
      </PageContainer>
    </>
  )
}

export default ContactPage
